import { render, staticRenderFns } from "./BDmap.vue?vue&type=template&id=d55abe04&scoped=true&"
import script from "./BDmap.vue?vue&type=script&lang=js&"
export * from "./BDmap.vue?vue&type=script&lang=js&"
import style0 from "./BDmap.vue?vue&type=style&index=0&id=d55abe04&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d55abe04",
  null
  
)

export default component.exports